/**
 * Карта города с текущей клиникой
 *
 * @param {Object} params
 * @param {String} params.coordLatitude - широта
 * @param {String} params.coordLongitude - долгота
 * @param {String} params.iconImageHref - своё изображение иконки метки
 * @param {String} params.map - имя карты
 * @param {String} params.iconLayout - изображение метки
 * @param {Array} params.iconImageSize - размеры метки
 * @param {Array} params.iconImageOffset - смещение метки
 * @param {Number} params.zoom - увеличение карты
 */
$.fn.mapClinicDetail = function (params) {

    const $self = $(this);
    const coordLatitude = $self.data(params.coordLatitude);
    const coordLongitude = $self.data(params.coordLongitude);
    const iconImageHref = $self.data(params.iconImageHref);
    const map = params.map;
    const iconLayout = params.iconLayout;
    const iconImageSize = params.iconImageSize;
    const iconImageOffset = params.iconImageOffset;
    const zoom = params.zoom;

    if (coordLatitude && coordLongitude && iconImageHref) {
        ymaps.ready(initMapClinicDetail);
    }

    /**
     * Инициализация яндекс карты
     */
    function initMapClinicDetail() {

        const myMap = new ymaps.Map(map, {
            center: [coordLatitude, coordLongitude],
            zoom: zoom,
            controls: [],
        });

        const myPlacemark = new ymaps.Placemark(myMap.getCenter(), {}, {
            // Опции.
            // Необходимо указать данный тип макета.
            iconLayout: iconLayout,
            // Своё изображение иконки метки.
            iconImageHref: iconImageHref,
            iconImageSize: iconImageSize,
            iconImageOffset: iconImageOffset
        });

        myMap.geoObjects.add(myPlacemark);
    }

    return this;
};

// инициализация
const init = function () {

    $('#map-clinic-detail').mapClinicDetail({
        coordLatitude: 'coord-latitude',
        coordLongitude: 'coord-longitude',
        iconImageHref: 'icon-image-href',
        map: 'map-clinic-detail',
        iconLayout: 'default#image',
        iconImageSize: [32, 32],
        iconImageOffset: [-16, -12],
        zoom: 14,
    });
};

if ($('#map-clinic-detail').length > 0) {
    init();
}